//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').component('processingVideo', {
    template: require('@legacy-components/common/processing-video/processing-video.html'),
  });
})();
